export default __webpack_public_path__ + "static/bentoSectionBg1-85832b01f5ae2f8ed056183a5bab4477.webp";